import {Link} from "react-router-dom";
import {t} from "i18next";
import classes from "./ChecklistViewTabs.module.css";

export type ChecklistViewTab = "checklist" | "documents";

/**
 * Checklist ⇄ Documents view switcher, rendered into the TopBar via
 * <TopBarSlot slot="center"> by ChecklistResource.
 *
 * Plain links styled as tabs — the two views are separate routes, so
 * navigation semantics (not Mantine <Tabs> state) are correct here.
 * The active tab is passed in rather than derived from the URL because
 * ChecklistView's effectiveTab has forcing rules the URL alone doesn't
 * capture (info-only checklists, checklists without documents).
 */
export const ChecklistViewTabs = ({
    activeTab,
    checklistUrl,
    documentsUrl,
}: {
    activeTab: ChecklistViewTab;
    checklistUrl: string;
    documentsUrl: string;
}) => (
    <nav className={classes.tabs} data-fullbleed>
        <Link
            to={checklistUrl}
            className={classes.tab}
            data-active={activeTab === "checklist" || undefined}
            aria-current={activeTab === "checklist" ? "page" : undefined}
        >
            {t("Word.Checklist")}
        </Link>
        <Link
            to={documentsUrl}
            className={classes.tab}
            data-active={activeTab === "documents" || undefined}
            aria-current={activeTab === "documents" ? "page" : undefined}
        >
            {t("Word.Templates")}
        </Link>
    </nav>
);
